namespace $ { $mol_style_attach( "hyoo/harp/app/app.view.css",
 "[hyoo_harp_app_content] {\n\tpadding: var(--mol_gap_block);\n}\n"
) }